module.exports = __webpack_public_path__ + "img/9788981102517.ada3d38e.jpg";